import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import Header from "../../Header/Header";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import { Row, Col, Button, Nav, Tab, Pagination } from "react-bootstrap";
import { Context } from "../../../utils/context";
import "react-datepicker/dist/react-datepicker.css";
import PendingOrdersTable from "./PendingOrdersTable/PendingOrdersTable";
import UnshippedTable from "./UnshippedTable/UnshippedTable";
import CancelledTable from "./CancelledTable/CancelledTable";
import RejectedTable from "./RejctedTable/RejecterTable";
import SentTable from "./SentTable/SentTable";
import ReturnTable from "./ReturnTable/ReturnTable";
import RefundTable from "./RefundTable/RefundTable";
import {
  IDS,
  OrderStatusIds,
  ReplaceStatusIds,
  ReturnStatusIds,
} from "../../../utils/common";
import ReplaceTable from "./ReplaceTable/ReplaceTable";
import PackingTable from "./Packing/Packing";
import AcceptedOrdersTable from "./AcceptedOrdersTable/AcceptedOrdersTable";
import QualityCheckTable from "./QualityCheck/QualityCheck";
import PickUpTable from "./PickUpTable/PickUpTable";
import DeliveredTable from "./DeliveredTable/DeliveredTable";
import StoppedTable from "./StoppedTable/StoppedTable";
import DiscardedTable from "./DiscardedTable/DiscardedTable";
import {
  FaInfoCircle,
  FaClock,
  FaCheckCircle,
  FaBoxOpen,
  FaClipboardCheck,
  FaTruckLoading,
  FaTruck,
  FaTimesCircle,
} from "react-icons/fa";
import "./OrdersTabs.css";
library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const { getData, Select2Data } = useContext(Context);

  const OrderByOptions = [
    { value: "ASC", label: "Sort-by date (Ascending)" },
    { value: "DESC", label: "Sort-by date (Descending)" },
  ];

  const resultsPerPageOptions = [
    { value: 25, label: "Results per page: 25" },
    { value: 50, label: "Results per page: 50" },
    { value: 100, label: "Results per page: 100" },
  ];

  const [statusCount, setStatusCount] = useState({});
  const [storeCategories, setStoreCategories] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [vendorServices, setVendorServices] = useState([]);

  const GetAllCounts = async () => {
    const response = await getData("/common/masters/all-count-order-status");
    setStatusCount(response?.data);
  };

  const getAllSCategories = async () => {
    const response = await getData("/common/masters/all-s-category");
    if (response?.success) {
      setStoreCategories(
        await Select2Data(response?.data?.allCategories, "s_category_id"),
      );
    }
  };

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
    if (response?.data?.Store_Detail) {
      const productCategory = await getData(
        `/common/masters/all-store-product-categories/${response?.data?.Store_Detail?.id}`,
      );
      if (productCategory?.success) {
        setProductCategories(
          await Select2Data(productCategory?.data, "p_category_id"),
        );
      }
      const vendorServices = await getData(
        `/common/masters/all-vendors-services/${response?.data?.Store_Detail?.id}`,
      );
      if (vendorServices?.success) {
        setVendorServices(
          await Select2Data(vendorServices?.data, "service_id"),
        );
      }
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  useEffect(() => {
    GetAllCounts();
    // getAllSCategories();
  }, []);

  const [payment_status, setPayment_status] = useState(null);
  const [return_status_id, setReturnStatus] = useState(1);
  const [searchOrderStatus, setSearchOrderSatatus] = useState(
    OrderStatusIds.PickupSchedued,
  );
  const [replace_order_status_id, setReplaceStatusId] = useState("");

  const [activeTab, setActiveTab] = useState("Pending");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Order lifecycle: steps 1-6 are the normal flow, the last tab is a closed state.
  const orderTabs = [
    {
      key: "Pending",
      label: "Pending",
      icon: <FaClock />,
      count: statusCount?.Pending,
      tone: "tone-warning",
      step: true,
      description: "New orders waiting for you to accept or reject.",
    },
    {
      key: "Accepted",
      label: "Accepted",
      icon: <FaCheckCircle />,
      count: statusCount?.Processing,
      tone: "tone-info",
      step: true,
      description: "Orders you accepted. Start preparing them next.",
    },
    {
      key: "Unshipped",
      label: "Preparing",
      icon: <FaBoxOpen />,
      count: statusCount?.Preparing,
      tone: "tone-info",
      step: true,
      description: "Orders being prepared and packed.",
    },
    {
      key: "QualityCheck",
      label: "Quality Check",
      icon: <FaClipboardCheck />,
      count: statusCount?.OrderUnderQualityCheck,
      tone: "tone-purple",
      step: true,
      description: "Packed orders being checked before dispatch.",
    },
    {
      key: "Pickup",
      label: "Pickup",
      icon: <FaTruckLoading />,
      count: statusCount?.PickupScheduled,
      tone: "tone-purple",
      step: true,
      description: "Orders ready or scheduled to be picked up by delivery.",
    },
    {
      key: "Delivered",
      label: "Delivered",
      icon: <FaTruck />,
      count: statusCount?.Delivered,
      tone: "tone-success",
      step: true,
      description: "Orders successfully delivered to customers.",
    },
    {
      key: "Rejected",
      label: "Rejected",
      icon: <FaTimesCircle />,
      count: statusCount?.Rejected,
      tone: "tone-danger",
      step: false,
      description: "Orders that were rejected and will not be fulfilled.",
    },
  ];
  const currentTab = orderTabs.find((t) => t.key === activeTab);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Orders"} link={"/employee/employee_details"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12 p-0 ">
            <div className="row MainRowsec me-0 ms-0 p-2">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  <div className="order-tab-holder">
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="Pending"
                    >
                      <Row className="p-2">
                        <Col sm={12}>
                          <div className="order-stage-bar">
                            <div className="order-stage-group-label">
                              Order workflow
                            </div>
                            <Nav
                              variant="pills"
                              className="order-stage-nav"
                              onSelect={(k) => setActiveTab(k)}
                            >
                              {orderTabs.map((tab, index) => (
                                <Nav.Item key={tab.key}>
                                  <Nav.Link
                                    eventKey={tab.key}
                                    className={`order-stage ${tab.tone}`}
                                    title={tab.description}
                                  >
                                    <span className="order-stage-icon">
                                      {tab.icon}
                                    </span>
                                    <span className="order-stage-text">
                                      <span className="order-stage-step">
                                        {tab.step
                                          ? `Step ${index + 1}`
                                          : "Closed"}
                                      </span>
                                      <span className="order-stage-label">
                                        {tab.label}
                                      </span>
                                    </span>
                                    <span className="order-stage-count">
                                      {tab.count ?? 0}
                                    </span>
                                  </Nav.Link>
                                </Nav.Item>
                              ))}
                            </Nav>
                            <div className="order-stage-hint">
                              <FaInfoCircle />
                              <span>
                                <b>{currentTab?.label}:</b>{" "}
                                {currentTab?.description}
                              </span>
                            </div>
                          </div>
                        </Col>

                        <Col sm={12}>
                          <Tab.Content>
                            {activeTab === "Pending" && (
                              <Tab.Pane eventKey="Pending">
                                <PendingOrdersTable
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  user={user}
                                  GetAllCounts={() => GetAllCounts()}
                                  activeTab={activeTab}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Accepted" && (
                              <Tab.Pane eventKey="Accepted">
                                <AcceptedOrdersTable
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  user={user}
                                  GetAllCounts={() => GetAllCounts()}
                                  activeTab={activeTab}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Unshipped" && (
                              <Tab.Pane eventKey="Unshipped">
                                <UnshippedTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}
                            {activeTab === "QualityCheck" && (
                              <Tab.Pane eventKey="QualityCheck">
                                <QualityCheckTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}
                            {activeTab === "Pickup" && (
                              <Tab.Pane eventKey="Pickup">
                                <PickUpTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}

                            {activeTab === "Delivered" && (
                              <Tab.Pane eventKey="Delivered">
                                <DeliveredTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )}
                            {/* <Tab.Pane eventKey="Packing">
                              <PackingTable
                                user={user}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                />
                                </Tab.Pane> */}

                            {activeTab === "Rejected" && (
                              <Tab.Pane eventKey="Rejected">
                                <CancelledTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                />
                              </Tab.Pane>
                            )}

                            {/* {activeTab === "Stopped" && (
                              <Tab.Pane eventKey="Stopped">
                                <StoppedTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                />
                              </Tab.Pane>
                            )} */}
                            {/* {activeTab === "Discarded" && (
                              <Tab.Pane eventKey="Discarded">
                                <DiscardedTable
                                  user={user}
                                  activeTab={activeTab}
                                  statusCount={statusCount}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                />
                              </Tab.Pane>
                            )} */}

                            {/* <Tab.Pane eventKey="Rejected">
                              <RejectedTable
                                user={user}
                                statusCount={statusCount}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                              />
                            </Tab.Pane> */}
                            {/* {activeTab === "Sent" && (
                              <Tab.Pane eventKey="Sent">
                                <SentTable
                                  user={user}
                                  OrderByOptions={OrderByOptions}
                                  resultsPerPageOptions={resultsPerPageOptions}
                                  storeCategories={storeCategories}
                                  productCategories={productCategories}
                                  vendorServices={vendorServices}
                                  statusCount={statusCount}
                                  activeTab={activeTab}
                                  handleTabClick={handleTabClick}
                                  searchOrderStatus={searchOrderStatus}
                                  setSearchOrderSatatus={setSearchOrderSatatus}
                                  GetAllCounts={() => GetAllCounts()}
                                />
                              </Tab.Pane>
                            )} */}

                            {/* <Tab.Pane eventKey="Returns">
                              <ReturnTable
                                GetAllCounts={GetAllCounts}
                                user={user}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                return_status_id={return_status_id}
                                setReturnStatus={setReturnStatus}
                                activeTab={activeTab}
                                handleTabClick={handleTabClick}
                              />
                            </Tab.Pane> */}

                            {/* <Tab.Pane eventKey="Refund">
                              <RefundTable
                                user={user}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                setPayment_status={setPayment_status}
                                payment_status={payment_status}
                                activeTab={activeTab}
                                handleTabClick={handleTabClick}
                              />
                            </Tab.Pane> */}

                            {/* <Tab.Pane eventKey="replace">
                              <ReplaceTable
                                user={user}
                                OrderByOptions={OrderByOptions}
                                resultsPerPageOptions={resultsPerPageOptions}
                                storeCategories={storeCategories}
                                productCategories={productCategories}
                                vendorServices={vendorServices}
                                statusCount={statusCount}
                                replace_order_status_id={
                                  replace_order_status_id
                                }
                                setReplaceStatusId={setReplaceStatusId}
                                activeTab={activeTab}
                                handleTabClick={handleTabClick}
                              />
                            </Tab.Pane> */}
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </div>

                  <div className=""></div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
